/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Assign_User_AriaInputs */

const en_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign to User`)
};

const fr_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigner a un utilisateur`)
};

const de_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dem Benutzer zuweisen`)
};

const it_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegna all'utente`)
};

const ru_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назначить пользователю`)
};

const es_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignar a usuario`)
};

const zh_cn2_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分配给用户`)
};

const ja_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーに割り当てる`)
};

const hi_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता को असाइन करें`)
};

const pt_pt2_explorer_info_assign_user_aria = /** @type {(inputs: Explorer_Info_Assign_User_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribuir ao usuário`)
};

/**
* | output |
* | --- |
* | "Assign to User" |
*
* @param {Explorer_Info_Assign_User_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_assign_user_aria = /** @type {((inputs?: Explorer_Info_Assign_User_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Assign_User_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_assign_user_aria(inputs)
	if (locale === "de") return de_explorer_info_assign_user_aria(inputs)
	if (locale === "it") return it_explorer_info_assign_user_aria(inputs)
	if (locale === "ru") return ru_explorer_info_assign_user_aria(inputs)
	if (locale === "es") return es_explorer_info_assign_user_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_assign_user_aria(inputs)
	if (locale === "ja") return ja_explorer_info_assign_user_aria(inputs)
	if (locale === "hi") return hi_explorer_info_assign_user_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_assign_user_aria(inputs)
	return en_explorer_info_assign_user_aria(inputs)
});